import script from "./dashboard-filter-bar.vue?vue&type=script&setup=true&lang=ts"
export * from "./dashboard-filter-bar.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__